import Container from '@components/global/Container';
import {
  CategoryNavigationSliceData,
  PageType,
} from '@adapters/prismic/types/slices';
import CategoryNavigationItem from './CategoryNavigationItem';

import styles from './CategoryNavigation.module.scss';

export interface CategoryNavigationProps {
  items: {
    category_nav_list: {
      data?: CategoryNavigationSliceData;
    };
  }[];
  trackPromos: boolean;
  pageType: PageType;
  sliceIndex: number;
}
const CategoryNavigation = ({
  items,
  trackPromos,
  pageType,
  sliceIndex,
}: CategoryNavigationProps) => (
  <Container>
    <div className={styles.categoryNavGridContainer}>
      {items.map((item, i) => {
        const {
          data: {
            category_image: categoryImage,
            category_title: categoryTitle,
            category_nav_links: categoryNavLinks,
            button_text: buttonText,
            button_link: buttonLink,
          } = {},
        } = item.category_nav_list;
        return (
          <CategoryNavigationItem
            key={categoryTitle}
            title={categoryTitle}
            image={categoryImage}
            link={buttonLink}
            trackPromos={trackPromos}
            pageType={pageType}
            navLinks={categoryNavLinks}
            text={buttonText}
            positionWithinSlice={i}
            sliceIndex={sliceIndex}
          />
        );
      })}
    </div>
  </Container>
);

export default CategoryNavigation;
